/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiDonationsByUserIdDonationsDonationidPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор пользователя"),
"DonationId": z.string().uuid().describe("Идентификатор платежа")
    })

/**
 * @description Успешно
 */
export const deleteApiDonationsByUserIdDonationsDonationid200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiDonationsByUserIdDonationsDonationid400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiDonationsByUserIdDonationsDonationid401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiDonationsByUserIdDonationsDonationid403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiDonationsByUserIdDonationsDonationid500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiDonationsByUserIdDonationsDonationidMutationResponseSchema = z.lazy(() => deleteApiDonationsByUserIdDonationsDonationid200Schema)